export default __webpack_public_path__ + "static/media/disable1.cf689bf3.png";